// extracted by mini-css-extract-plugin
module.exports = {"city":"UserLocation_city__1436J"};